<ion-modal class="modalFoto" #modal (ionModalWillDismiss)="onDismiss()">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="modal.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
        <ion-title>Hacer foto</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div [style.visibility]="stopped ? 'hidden' : 'visible'" *ngIf="!stopped" [id]="identifier" style="width: 1920; height: 1080;"></div>
      <img *ngIf="stopped" [src]="foto" />
    </ion-content>
    <ion-footer class="footerModalPhoto">
      <ion-buttons>
        <ion-button class="btn1 ml-auto" (click)="hacerFoto()" *ngIf="!stopped"><ion-icon name="camera" class="mr-2"></ion-icon>Hacer foto</ion-button>
        <ion-button color="danger" slot="start" (click)="repetirFoto()" *ngIf="stopped"><ion-icon name="refresh-outline" class="me-2"></ion-icon>Repetir foto</ion-button>
        <ion-button class="btn1" slot="end" (click)="confirmarFoto()" *ngIf="stopped"><ion-icon name="checkmark-circle" class="me-2"></ion-icon>Confimar</ion-button>
      </ion-buttons>
    </ion-footer>
  </ng-template>
</ion-modal>
